import { graphQueryPromise } from './helpers';

export const queryCustomerPermissions = () => {
  const query = `query customerPermissions {
    customerPermissions {
      canImportJobs
      canPost1099
      canPostW2
      canSeeBudgets
      canUseStartAndCompletePin
      canUseTryouts
      canUseWanda
      canUseAutomatedPayments
    }
  }`;
  return graphQueryPromise(query);
};
